import React, { useState, Component } from 'react';
import { Search, Filter, X, MessageSquare, Tag, ChevronRight, Mail, Edit3, FileText, Check, Minus, Plus, Trash2, Phone, LogIn, CreditCard, Building2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { OfferForm } from '../../components/admin/OfferConfigurator';
const mockConsumers = [{
  id: 1,
  name: 'Lissette Berpan',
  firstName: 'Lissette',
  lastName: 'Berpan',
  account: '102863517',
  balance: 4244.12,
  status: 'Payment Plan',
  lastContact: '2 days ago',
  activeOffer: 'Yes',
  address: '17 Collier Cir',
  city: 'Ridley Park',
  state: 'PA',
  zip: '19078',
  phone: '(215) 571-5589',
  originalEmail: 'lissettefernandez@me.com',
  currentEmail: 'lissette.b@me.com',
  ssnLast4: '3238',
  dob: '04/30/1975',
  permissions: {
    portalAccess: true,
    canMakePayments: true,
    singleAchAccepted: false,
    singleCardAccepted: true
  },
  offers: [{
    type: 'Settlement',
    detail: '$2,970',
    due: 'May 12, 2026'
  }, {
    type: 'Plan',
    detail: '6x $707',
    due: 'Jun 1, 2026'
  }, {
    type: 'Pay in Full',
    detail: '$4,244',
    due: 'May 5, 2026'
  }],
  due: 'May 12, 2026',
  actionStatus: 'Expiring soon'
}, {
  id: 2,
  name: 'Michael Chang',
  firstName: 'Michael',
  lastName: 'Chang',
  account: '102863518',
  balance: 1250.0,
  status: 'Payment Plan',
  lastContact: '1 week ago',
  activeOffer: 'Yes',
  address: '442 Birch St',
  city: 'Wynnewood',
  state: 'PA',
  zip: '19096',
  phone: '(610) 442-7811',
  originalEmail: 'mchang92@gmail.com',
  currentEmail: 'mchang92@gmail.com',
  ssnLast4: '7142',
  dob: '08/12/1988',
  permissions: {
    portalAccess: true,
    canMakePayments: true,
    singleAchAccepted: true,
    singleCardAccepted: true
  },
  offers: [{
    type: 'Plan',
    detail: '6x $208',
    due: 'Oct 12, 2026'
  }],
  due: 'Oct 12, 2026',
  actionStatus: 'On track'
}, {
  id: 3,
  name: 'David Smith',
  firstName: 'David',
  lastName: 'Smith',
  account: '102863519',
  balance: 850.5,
  status: 'Delinquent',
  lastContact: 'Today',
  activeOffer: 'No',
  address: '88 Maple Ave',
  city: 'Media',
  state: 'PA',
  zip: '19063',
  phone: '(484) 220-9912',
  originalEmail: 'd.smith@yahoo.com',
  currentEmail: 'd.smith@yahoo.com',
  ssnLast4: '4421',
  dob: '11/03/1981',
  permissions: {
    portalAccess: true,
    canMakePayments: true,
    singleAchAccepted: true,
    singleCardAccepted: true
  },
  offers: [{
    type: 'Settlement',
    detail: '$595',
    due: 'May 12, 2026'
  }, {
    type: 'Plan',
    detail: '4x $213',
    due: 'Jun 5, 2026'
  }],
  due: 'May 12, 2026',
  actionStatus: 'No response'
}, {
  id: 4,
  name: 'Amanda Cole',
  firstName: 'Amanda',
  lastName: 'Cole',
  account: '102863520',
  balance: 0.0,
  status: 'Paid',
  lastContact: '1 month ago',
  activeOffer: 'No',
  address: '12 Oak Lane',
  city: 'Newtown Square',
  state: 'PA',
  zip: '19073',
  phone: '(610) 555-3344',
  originalEmail: 'acole@outlook.com',
  currentEmail: 'acole@outlook.com',
  ssnLast4: '9982',
  dob: '02/19/1990',
  permissions: {
    portalAccess: false,
    canMakePayments: false,
    singleAchAccepted: false,
    singleCardAccepted: false
  },
  offers: null as any,
  due: '—',
  actionStatus: 'Settled'
}, {
  id: 5,
  name: 'Robert Fox',
  firstName: 'Robert',
  lastName: 'Fox',
  account: '102863521',
  balance: 5430.25,
  status: 'Delinquent',
  lastContact: '3 days ago',
  activeOffer: 'No',
  address: '301 Pine Rd',
  city: 'Drexel Hill',
  state: 'PA',
  zip: '19026',
  phone: '(610) 998-2210',
  originalEmail: 'rfox@hotmail.com',
  currentEmail: 'robert.fox@hotmail.com',
  ssnLast4: '5519',
  dob: '06/27/1972',
  permissions: {
    portalAccess: false,
    canMakePayments: true,
    singleAchAccepted: false,
    singleCardAccepted: true
  },
  offers: [{
    type: 'Settlement',
    detail: '$3,800',
    due: 'Apr 30, 2026'
  }, {
    type: 'Plan',
    detail: '12x $453',
    due: 'May 30, 2026'
  }, {
    type: 'Pay in Full',
    detail: '$5,430',
    due: 'Apr 30, 2026'
  }],
  due: 'Past due',
  actionStatus: 'No response'
}];
type Consumer = (typeof mockConsumers)[0];
type TabId = 'overview' | 'activity' | 'payments' | 'account';
export function Consumers() {
  const [selectedConsumer, setSelectedConsumer] = useState<Consumer | null>(null);
  const [offerFor, setOfferFor] = useState<Consumer | null>(null);
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());
  const [groupOfferOpen, setGroupOfferOpen] = useState(false);
  const toggleOne = (id: number) => {
    setSelectedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);else next.add(id);
      return next;
    });
  };
  const toggleAll = () => {
    setSelectedIds(prev => prev.size === mockConsumers.length ? new Set() : new Set(mockConsumers.map(c => c.id)));
  };
  const allChecked = selectedIds.size === mockConsumers.length && mockConsumers.length > 0;
  const someChecked = selectedIds.size > 0 && !allChecked;
  const selectedConsumers = mockConsumers.filter(c => selectedIds.has(c.id));
  return <div className="p-8 max-w-[1600px] mx-auto flex flex-col h-full" data-id="element-1028">
      <div className="flex items-center justify-between mb-6 shrink-0" data-id="element-1029">
        <h1 className="text-2xl font-bold text-brand-navy" data-id="element-1030">Consumers</h1>
        <div className="flex items-center gap-2" data-id="element-1031">
          <button onClick={() => setGroupOfferOpen(true)} className="flex items-center gap-2 bg-white border border-brand-navy text-brand-navy hover:bg-brand-navy hover:text-white px-4 py-2 rounded-lg text-sm font-bold transition-colors" data-id="element-1032">
            <Tag size={14} data-id="element-1033" /> Create Offer
          </button>
          <button className="bg-brand-red hover:bg-red-800 text-white px-4 py-2 rounded-lg text-sm font-bold transition-colors shadow-sm" data-id="element-1034">
            + Add Consumer
          </button>
        </div>
      </div>

      <div className="flex items-center gap-4 mb-6 shrink-0" data-id="element-1035">
        <div className="relative flex-1 max-w-md" data-id="element-1036">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1037" />
          <input type="text" placeholder="Search by name or account..." className="w-full pl-9 pr-4 py-2 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-navy" data-id="element-1038" />
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-1039">
          <Filter size={16} data-id="element-1040" /> Status
        </button>
      </div>

      {/* Bulk action bar */}
      <AnimatePresence data-id="element-1041">
        {selectedIds.size > 0 && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.15
      }} className="mb-3 shrink-0 bg-brand-navy text-white rounded-xl px-4 py-3 flex items-center justify-between gap-4 shadow-sm" data-id="element-1042">
            <div className="flex items-center gap-3 min-w-0" data-id="element-1043">
              <span className="bg-white/15 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-1044">
                {selectedIds.size} selected
              </span>
              <p className="text-sm font-medium truncate hidden sm:block" data-id="element-1045">
                {selectedConsumers.slice(0, 3).map(c => c.name).join(', ')}
                {selectedConsumers.length > 3 ? ` +${selectedConsumers.length - 3} more` : ''}
              </p>
            </div>
            <div className="flex items-center gap-2 shrink-0" data-id="element-1046">
              <button onClick={() => setGroupOfferOpen(true)} className="bg-brand-red hover:bg-red-800 text-white text-sm font-bold px-4 py-2 rounded-lg transition-colors flex items-center gap-2" data-id="element-1047">
                <Tag size={14} data-id="element-1048" /> Configure Group Offer
              </button>
              <button onClick={() => setSelectedIds(new Set())} className="text-sm font-bold text-white/70 hover:text-white px-3 py-2 transition-colors" data-id="element-1049">
                Clear
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden flex-1 flex flex-col" data-id="element-1050">
        <div className="overflow-x-auto flex-1" data-id="element-1051">
          <table className="w-full text-left border-collapse" data-id="element-1052">
            <thead data-id="element-1053">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1054">
                <th className="pl-6 pr-2 py-4 w-10" data-id="element-1055">
                  <input type="checkbox" checked={allChecked} ref={el => {
                  if (el) el.indeterminate = someChecked;
                }} onChange={toggleAll} className="h-4 w-4 rounded border-gray-300 text-brand-red focus:ring-brand-red cursor-pointer" aria-label="Select all" data-id="element-1056" />
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1057">
                  Name
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1058">
                  Account #
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1059">
                  Balance
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1060">
                  Offer
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1061">
                  Due
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1062">
                  Last Contact
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1063">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1064">
              {mockConsumers.map(c => <tr key={c.id} onClick={() => setSelectedConsumer(c)} className={`hover:bg-gray-50 cursor-pointer transition-colors ${selectedIds.has(c.id) ? 'bg-brand-red/[0.03]' : ''}`} data-id="element-1065">
                  <td className="pl-6 pr-2 py-4 w-10" onClick={e => e.stopPropagation()} data-id="element-1066">
                    <input type="checkbox" checked={selectedIds.has(c.id)} onChange={() => toggleOne(c.id)} className="h-4 w-4 rounded border-gray-300 text-brand-red focus:ring-brand-red cursor-pointer" aria-label={`Select ${c.name}`} data-id="element-1067" />
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-brand-navy" data-id="element-1068">
                    {c.name}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600 font-mono" data-id="element-1069">
                    {c.account}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-brand-dark" data-id="element-1070">
                    $
                    {c.balance.toLocaleString(undefined, {
                  minimumFractionDigits: 2
                })}
                  </td>
                  <td className="px-6 py-4 text-sm" data-id="element-1071">
                    {c.offers && c.offers.length > 0 ? <div className="space-y-1" data-id="element-1072">
                        {c.offers.map((o: any, idx: number) => <div key={idx} className="flex items-center gap-2" data-id="element-1073">
                            <OfferTypeTag type={o.type} data-id="element-1074" />
                            <span className="text-gray-600 font-medium" data-id="element-1075">
                              {o.detail}
                            </span>
                          </div>)}
                      </div> : <span className="text-gray-400" data-id="element-1076">—</span>}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium" data-id="element-1077">
                    {c.offers && c.offers.length > 0 ? <div className="space-y-1" data-id="element-1078">
                        {c.offers.map((o: any, idx: number) => <div key={idx} className="text-gray-600" data-id="element-1079">
                            {o.due || '—'}
                          </div>)}
                      </div> : <span className={c.due === 'Past due' ? 'text-brand-red' : 'text-gray-600'} data-id="element-1080">
                        {c.due}
                      </span>}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500" data-id="element-1081">
                    {c.lastContact}
                  </td>
                  <td className="px-6 py-4" data-id="element-1082">
                    <ActionBadge action={c.actionStatus} data-id="element-1083" />
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Consumer Details Drawer */}
      <AnimatePresence data-id="element-1084">
        {selectedConsumer && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-[#1a2332]/40 backdrop-blur-sm z-40" onClick={() => setSelectedConsumer(null)} data-id="element-1085" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed inset-y-0 right-0 w-full max-w-xl bg-white shadow-2xl z-50 flex flex-col border-l border-gray-200" data-id="element-1086">
              <ConsumerDetail consumer={selectedConsumer} onClose={() => setSelectedConsumer(null)} onConfigureOffer={() => setOfferFor(selectedConsumer)} data-id="element-1087" />
            </motion.div>
          </>}
      </AnimatePresence>

      {/* Offer Configurator Drawer */}
      <AnimatePresence data-id="element-1088">
        {offerFor && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-[#1a2332]/40 backdrop-blur-sm z-[60]" onClick={() => setOfferFor(null)} data-id="element-1089" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed inset-y-0 right-0 w-full max-w-3xl bg-white shadow-2xl z-[70] flex flex-col border-l border-gray-200" data-id="element-1090">
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 shrink-0 bg-gray-50" data-id="element-1091">
                <div data-id="element-1092">
                  <h2 className="text-lg font-bold text-brand-navy" data-id="element-1093">
                    Configure Offer
                  </h2>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-1094">
                    For {offerFor.name} · Acct #{offerFor.account}
                  </p>
                </div>
                <button onClick={() => setOfferFor(null)} className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-200 transition-colors" data-id="element-1095">
                  <X size={20} data-id="element-1096" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto p-6" data-id="element-1097">
                <OfferForm onClose={() => setOfferFor(null)} data-id="element-1098" />
              </div>
            </motion.div>
          </>}
      </AnimatePresence>

      {/* Group Offer Drawer */}
      <AnimatePresence data-id="element-1099">
        {groupOfferOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-[#1a2332]/40 backdrop-blur-sm z-[60]" onClick={() => setGroupOfferOpen(false)} data-id="element-1100" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed inset-y-0 right-0 w-full max-w-3xl bg-white shadow-2xl z-[70] flex flex-col border-l border-gray-200" data-id="element-1101">
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 shrink-0 bg-gray-50" data-id="element-1102">
                <div data-id="element-1103">
                  <h2 className="text-lg font-bold text-brand-navy" data-id="element-1104">
                    Configure Group Offer
                  </h2>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-1105">
                    Applying to {selectedConsumers.length}{' '}
                    {selectedConsumers.length === 1 ? 'consumer' : 'consumers'}
                  </p>
                </div>
                <button onClick={() => setGroupOfferOpen(false)} className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-200 transition-colors" data-id="element-1106">
                  <X size={20} data-id="element-1107" />
                </button>
              </div>
              <div className="px-6 py-4 border-b border-gray-100 bg-amber-50/50 shrink-0" data-id="element-1108">
                <p className="text-xs font-bold text-amber-800 uppercase tracking-wider mb-2" data-id="element-1109">
                  Selected Consumers
                </p>
                <div className="flex flex-wrap gap-1.5 max-h-24 overflow-y-auto" data-id="element-1110">
                  {selectedConsumers.map(c => <span key={c.id} className="inline-flex items-center gap-1.5 bg-white border border-amber-200 text-brand-navy text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-1111">
                      {c.name}
                      <span className="text-[10px] text-gray-400 font-mono" data-id="element-1112">
                        #{c.account}
                      </span>
                    </span>)}
                </div>
              </div>
              <div className="flex-1 overflow-y-auto p-6" data-id="element-1113">
                <OfferForm onClose={() => {
              setGroupOfferOpen(false);
              setSelectedIds(new Set());
            }} data-id="element-1114" />
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}
function ConsumerDetail({
  consumer,
  onClose,
  onConfigureOffer
}: {
  consumer: Consumer;
  onClose: () => void;
  onConfigureOffer: () => void;
}) {
  const [tab, setTab] = useState<TabId>('overview');
  const tabs: {
    id: TabId;
    label: string;
  }[] = [{
    id: 'overview',
    label: 'Overview'
  }, {
    id: 'activity',
    label: 'Activity'
  }, {
    id: 'payments',
    label: 'Payment History'
  }, {
    id: 'account',
    label: 'Account Info'
  }];
  return <>
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 shrink-0 bg-gray-50" data-id="element-1115">
        <h2 className="text-lg font-bold text-brand-navy" data-id="element-1116">Consumer Details</h2>
        <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-200 transition-colors" data-id="element-1117">
          <X size={20} data-id="element-1118" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto" data-id="element-1119">
        {/* Header */}
        <div className="px-6 pt-6 pb-5 border-b border-gray-100" data-id="element-1120">
          <h3 className="text-2xl font-bold text-brand-navy mb-1" data-id="element-1121">
            {consumer.name}
          </h3>
          <p className="text-sm text-gray-500 font-mono mb-3" data-id="element-1122">
            Consumer · {consumer.account}
          </p>
          <div className="flex items-center gap-2" data-id="element-1123">
            <StatusBadge status={consumer.status} data-id="element-1124" />
            <span className="text-xs text-gray-400" data-id="element-1125">
              Last contact: {consumer.lastContact}
            </span>
          </div>
        </div>

        {/* Tabs */}
        <div className="px-6 border-b border-gray-200 sticky top-0 bg-white z-10" data-id="element-1126">
          <div className="flex gap-6" data-id="element-1127">
            {tabs.map(t => <button key={t.id} onClick={() => setTab(t.id)} className={`relative py-3 text-sm font-bold transition-colors ${tab === t.id ? 'text-brand-red' : 'text-gray-500 hover:text-brand-navy'}`} data-id="element-1128">
                {t.label}
                {tab === t.id && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand-red" data-id="element-1129"></span>}
              </button>)}
          </div>
        </div>

        {tab === 'overview' && <OverviewTab consumer={consumer} onConfigureOffer={onConfigureOffer} data-id="element-1130" />}
        {tab === 'activity' && <ActivityTab data-id="element-1131" />}
        {tab === 'payments' && <PaymentHistoryTab consumer={consumer} data-id="element-1132" />}
        {tab === 'account' && <AccountInfoTab consumer={consumer} data-id="element-1133" />}
      </div>
    </>;
}
function OverviewTab({
  consumer,
  onConfigureOffer
}: {
  consumer: Consumer;
  onConfigureOffer: () => void;
}) {
  return <>
      {/* Active Offer */}
      {consumer.offers && consumer.offers.length > 0 ? <div className="px-6 py-5 border-b border-gray-100" data-id="element-1134">
          <div className="flex items-center justify-between mb-3" data-id="element-1135">
            <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1136">
              Active Offer
            </h4>
            <button onClick={onConfigureOffer} className="text-xs font-bold text-brand-red hover:text-red-800 flex items-center gap-1 transition-colors" data-id="element-1137">
              <Plus size={12} data-id="element-1138" /> Create New Offer
            </button>
          </div>
          <div className="space-y-2" data-id="element-1139">
            {consumer.offers.map((o: any, idx: number) => {
          const palette = o.type === 'Settlement' ? {
            bg: 'from-green-50 to-emerald-50',
            border: 'border-green-200',
            label: 'text-green-800',
            hover: 'hover:bg-green-100'
          } : o.type === 'Plan' ? {
            bg: 'from-blue-50 to-sky-50',
            border: 'border-blue-200',
            label: 'text-blue-800',
            hover: 'hover:bg-blue-100'
          } : {
            bg: 'from-purple-50 to-violet-50',
            border: 'border-purple-200',
            label: 'text-purple-800',
            hover: 'hover:bg-purple-100'
          };
          return <div key={idx} className={`bg-gradient-to-br ${palette.bg} border ${palette.border} rounded-xl p-4`} data-id="element-1140">
                  <div className="flex items-start justify-between gap-4" data-id="element-1141">
                    <div className="flex-1" data-id="element-1142">
                      <p className={`text-xs font-bold ${palette.label} uppercase tracking-wider`} data-id="element-1143">
                        {o.type}
                      </p>
                      <p className="text-2xl font-bold text-brand-navy mt-1" data-id="element-1144">
                        {o.detail}
                      </p>
                    </div>
                    <div className="flex flex-col items-end gap-2" data-id="element-1145">
                      <div className="flex items-center gap-1" data-id="element-1146">
                        <button onClick={onConfigureOffer} className={`p-1.5 rounded-md ${palette.hover} text-gray-500 hover:text-brand-navy transition-colors`} title="Edit offer" data-id="element-1147">
                          <Edit3 size={14} data-id="element-1148" />
                        </button>
                        <button className={`p-1.5 rounded-md ${palette.hover} text-gray-500 hover:text-brand-red transition-colors`} title="Delete offer" data-id="element-1149">
                          <Trash2 size={14} data-id="element-1150" />
                        </button>
                      </div>
                      {o.due && <div className="text-right" data-id="element-1151">
                          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-1152">
                            Due
                          </p>
                          <p className="text-xs font-bold text-brand-navy mt-0.5" data-id="element-1153">
                            {o.due}
                          </p>
                        </div>}
                    </div>
                  </div>
                </div>;
        })}
          </div>
        </div> : <div className="px-6 py-5 border-b border-gray-100" data-id="element-1154">
          <div className="flex items-center justify-between mb-3" data-id="element-1155">
            <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1156">
              Active Offer
            </h4>
          </div>
          <div className="border border-dashed border-gray-300 rounded-xl p-5 text-center" data-id="element-1157">
            <p className="text-sm text-gray-500 mb-3" data-id="element-1158">
              No active offer configured
            </p>
            <button onClick={onConfigureOffer} className="inline-flex items-center gap-2 px-4 py-2 bg-brand-navy text-white text-sm font-bold rounded-lg hover:bg-brand-navy/90 transition-colors" data-id="element-1159">
              <Tag size={14} data-id="element-1160" /> Configure Offer
            </button>
          </div>
        </div>}

      {/* Quick Actions */}
      <div className="px-6 py-5 border-b border-gray-100" data-id="element-1161">
        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3" data-id="element-1162">
          Quick Actions
        </h4>
        <div className="grid grid-cols-2 gap-2" data-id="element-1163">
          <button onClick={onConfigureOffer} className="flex items-center justify-center gap-2 px-3 py-2 border border-gray-200 rounded-lg text-sm font-bold text-brand-navy hover:bg-gray-50 transition-colors" data-id="element-1164">
            <Tag size={14} data-id="element-1165" /> {consumer.offers ? 'Edit Offer' : 'New Offer'}
          </button>
          <Link to={`/portal/admin/communications?channel=sms&consumer=${encodeURIComponent(consumer.name)}`} className="flex items-center justify-center gap-2 px-3 py-2 border border-gray-200 rounded-lg text-sm font-bold text-brand-navy hover:bg-gray-50 transition-colors" data-id="element-1166">
            <MessageSquare size={14} data-id="element-1167" /> Send SMS
          </Link>
          <Link to={`/portal/admin/communications?channel=email&consumer=${encodeURIComponent(consumer.name)}`} className="flex items-center justify-center gap-2 px-3 py-2 border border-gray-200 rounded-lg text-sm font-bold text-brand-navy hover:bg-gray-50 transition-colors" data-id="element-1168">
            <Mail size={14} data-id="element-1169" /> Send Email
          </Link>
          <button className="flex items-center justify-center gap-2 px-3 py-2 border border-gray-200 rounded-lg text-sm font-bold text-brand-navy hover:bg-gray-50 transition-colors" data-id="element-1170">
            <FileText size={14} data-id="element-1171" /> Send File
          </button>
          <button className="col-span-2 flex items-center justify-center gap-2 px-3 py-2 border border-gray-200 rounded-lg text-sm font-bold text-brand-navy hover:bg-gray-50 transition-colors" data-id="element-1172">
            <Edit3 size={14} data-id="element-1173" /> Edit Personal Information
          </button>
        </div>
      </div>

      {/* Balance */}
      <div className="px-6 py-5 border-b border-gray-100" data-id="element-1174">
        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3" data-id="element-1175">
          Account Balance
        </h4>
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 flex items-center justify-between" data-id="element-1176">
          <span className="text-sm text-gray-500" data-id="element-1177">Current Balance</span>
          <span className="text-2xl font-bold text-brand-navy" data-id="element-1178">
            $
            {consumer.balance.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })}
          </span>
        </div>
      </div>

      <AccountInfoTab consumer={consumer} data-id="element-1179" />
    </>;
}
const activityEvents = [{
  id: 1,
  type: 'sms',
  title: 'SMS sent — Settlement reminder',
  timeAgo: '2 days ago',
  detail: 'Today, 10:42 AM · Outbound',
  tags: ['Reminder', 'Settlement']
}, {
  id: 2,
  type: 'call',
  title: 'Outbound call — Discussed payment options',
  timeAgo: '5 days ago',
  detail: 'May 28, 2026 · 2m 14s · Voicemail left',
  tags: ['Outbound', 'Voicemail']
}, {
  id: 3,
  type: 'email',
  title: 'Email sent — Settlement offer details',
  timeAgo: '1 week ago',
  detail: 'May 26, 2026 · Opened',
  tags: ['Offer sent', 'Opened']
}, {
  id: 4,
  type: 'login',
  title: 'Consumer logged into portal',
  timeAgo: '2 weeks ago',
  detail: 'May 19, 2026 · Web · Chrome',
  tags: ['Portal']
}, {
  id: 5,
  type: 'payment',
  title: 'Payment received — $700.00',
  timeAgo: '3 weeks ago',
  detail: 'May 12, 2026 · ACH · Payment plan',
  tags: ['Payment plan', 'ACH']
}, {
  id: 6,
  type: 'call',
  title: 'Initial outreach call',
  timeAgo: '1 month ago',
  detail: 'May 1, 2026 · 4m 02s · Spoke with consumer',
  tags: ['Outbound', 'Connected']
}];
function getActivityIcon(type: string) {
  switch (type) {
    case 'sms':
      return {
        icon: MessageSquare,
        bg: 'bg-blue-100',
        color: 'text-blue-600'
      };
    case 'call':
      return {
        icon: Phone,
        bg: 'bg-amber-100',
        color: 'text-amber-600'
      };
    case 'email':
      return {
        icon: Mail,
        bg: 'bg-purple-100',
        color: 'text-purple-600'
      };
    case 'login':
      return {
        icon: LogIn,
        bg: 'bg-gray-100',
        color: 'text-gray-600'
      };
    case 'payment':
      return {
        icon: CreditCard,
        bg: 'bg-green-100',
        color: 'text-green-600'
      };
    default:
      return {
        icon: FileText,
        bg: 'bg-gray-100',
        color: 'text-gray-600'
      };
  }
}
function ActivityTab() {
  return <div className="px-6 py-5" data-id="element-1180">
      <ol className="relative border-l-2 border-gray-100 ml-3 space-y-6" data-id="element-1181">
        {activityEvents.map(e => {
        const {
          icon: Icon,
          bg,
          color
        } = getActivityIcon(e.type);
        return <li key={e.id} className="ml-5 relative" data-id="element-1182">
              <span className={`absolute -left-[34px] top-0.5 flex items-center justify-center w-7 h-7 rounded-full ring-4 ring-white ${bg} ${color}`} data-id="element-1183">
                <Icon size={12} data-id="element-1184" />
              </span>
              <div className="bg-white border border-gray-200 rounded-lg p-3 hover:border-gray-300 transition-colors" data-id="element-1185">
                <p className="text-sm font-bold text-brand-navy leading-tight" data-id="element-1186">
                  {e.title}
                </p>
                <p className="text-xs text-gray-500 mt-1" data-id="element-1187">{e.detail}</p>
                <div className="flex items-center gap-1.5 mt-2 flex-wrap" data-id="element-1188">
                  <span className="text-[10px] text-gray-400 font-medium" data-id="element-1189">
                    {e.timeAgo}
                  </span>
                  {e.tags.map((t, i) => <span key={i} className="text-[10px] font-bold text-gray-600 bg-gray-100 px-1.5 py-0.5 rounded" data-id="element-1190">
                      {t}
                    </span>)}
                </div>
              </div>
            </li>;
      })}
      </ol>
    </div>;
}
const paymentHistory = [{
  id: 1,
  date: 'May 15, 2026',
  timeAgo: '2 weeks ago',
  amount: 707.0,
  method: 'ACH',
  plan: 'Payment Plan',
  status: 'Completed',
  ref: 'REF-284910',
  processedOn: 'May 16, 2026',
  note: 'Installment 4 of 6 — auto-debit from Wells Fargo ····8821.'
}, {
  id: 2,
  date: 'Apr 15, 2026',
  timeAgo: '1 month ago',
  amount: 707.0,
  method: 'ACH',
  plan: 'Payment Plan',
  status: 'Completed',
  ref: 'REF-284891',
  processedOn: 'Apr 16, 2026',
  note: 'Installment 3 of 6 — auto-debit from Wells Fargo ····8821.'
}, {
  id: 3,
  date: 'Mar 15, 2026',
  timeAgo: '2 months ago',
  amount: 707.0,
  method: 'Card · ending 4421',
  plan: 'Payment Plan',
  status: 'Completed',
  ref: 'REF-284872',
  processedOn: 'Mar 15, 2026',
  note: 'Installment 2 of 6 — Visa ····4421 (one-time).'
}, {
  id: 4,
  date: 'Feb 12, 2026',
  timeAgo: '3 months ago',
  amount: 500.0,
  method: 'Card · ending 4421',
  plan: 'Initial Settlement',
  status: 'Completed',
  ref: 'REF-284830',
  processedOn: 'Feb 12, 2026',
  note: 'Initial good-faith payment to open settlement plan.'
}];
function PaymentHistoryTab({
  consumer
}: {
  consumer: Consumer;
}) {
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const paid = paymentHistory.reduce((sum, p) => sum + p.amount, 0);
  const total = paid + consumer.balance;
  const pct = total > 0 ? Math.min(100, paid / total * 100) : 0;
  return <div className="px-6 py-5 space-y-5" data-id="element-1191">
      {/* Progress summary */}
      <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-4" data-id="element-1192">
        <div className="flex items-baseline justify-between mb-1" data-id="element-1193">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1194">
            Total Balance
          </p>
          <p className="text-xs font-medium text-gray-500" data-id="element-1195">
            {paymentHistory.length}{' '}
            {paymentHistory.length === 1 ? 'payment' : 'payments'}
          </p>
        </div>
        <p className="text-2xl font-bold text-brand-navy mb-3" data-id="element-1196">
          $
          {total.toLocaleString(undefined, {
          minimumFractionDigits: 2
        })}
        </p>
        <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden mb-2" data-id="element-1197">
          <div className="h-full bg-brand-navy rounded-full transition-all duration-500" style={{
          width: `${pct}%`
        }} data-id="element-1198"></div>
        </div>
        <div className="flex items-center justify-between text-xs" data-id="element-1199">
          <div data-id="element-1200">
            <p className="text-gray-400 font-medium" data-id="element-1201">Paid to date</p>
            <p className="font-bold text-green-700" data-id="element-1202">
              $
              {paid.toLocaleString(undefined, {
              minimumFractionDigits: 2
            })}
            </p>
          </div>
          <div className="text-right" data-id="element-1203">
            <p className="text-gray-400 font-medium" data-id="element-1204">Remaining</p>
            <p className="font-bold text-brand-navy" data-id="element-1205">
              $
              {consumer.balance.toLocaleString(undefined, {
              minimumFractionDigits: 2
            })}
            </p>
          </div>
        </div>
      </div>

      {/* Timeline */}
      <ol className="relative border-l-2 border-gray-100 ml-3 space-y-3" data-id="element-1206">
        {paymentHistory.map(p => {
        const isOpen = expandedId === p.id;
        return <li key={p.id} className="ml-5 relative" data-id="element-1207">
              <span className="absolute -left-[34px] top-0.5 flex items-center justify-center w-7 h-7 rounded-full ring-4 ring-white bg-green-100 text-green-600" data-id="element-1208">
                {p.method.startsWith('ACH') ? <Building2 size={12} data-id="element-1209" /> : <CreditCard size={12} data-id="element-1210" />}
              </span>
              <button type="button" onClick={() => setExpandedId(isOpen ? null : p.id)} className={`w-full text-left bg-white border rounded-lg p-3 transition-colors ${isOpen ? 'border-brand-navy' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-1211">
                <div className="flex items-start justify-between gap-2" data-id="element-1212">
                  <p className="text-sm font-bold text-brand-navy" data-id="element-1213">
                    $
                    {p.amount.toLocaleString(undefined, {
                  minimumFractionDigits: 2
                })}{' '}
                    · {p.plan}
                  </p>
                  <div className="flex items-center gap-2 shrink-0" data-id="element-1214">
                    <span className="px-2 py-0.5 rounded-full bg-green-50 text-green-700 text-[10px] font-bold border border-green-200" data-id="element-1215">
                      {p.status}
                    </span>
                    <ChevronRight size={14} className={`text-gray-400 transition-transform ${isOpen ? 'rotate-90' : ''}`} data-id="element-1216" />
                  </div>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-1217">
                  {p.date} · {p.method}
                </p>
                {!isOpen && <div className="flex items-center gap-1.5 mt-2 flex-wrap" data-id="element-1218">
                    <span className="text-[10px] text-gray-400 font-medium" data-id="element-1219">
                      {p.timeAgo}
                    </span>
                    <span className="text-[10px] font-bold text-gray-600 bg-gray-100 px-1.5 py-0.5 rounded font-mono" data-id="element-1220">
                      Acct {consumer.account}
                    </span>
                    <span className="text-[10px] font-bold text-gray-600 bg-gray-100 px-1.5 py-0.5 rounded font-mono" data-id="element-1221">
                      {p.ref}
                    </span>
                  </div>}
              </button>
              <AnimatePresence initial={false} data-id="element-1222">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} className="overflow-hidden" data-id="element-1223">
                    <div className="mt-2 bg-gray-50 border border-gray-200 rounded-lg p-3 space-y-2" data-id="element-1224">
                      <DetailRow label="Reference" value={p.ref} mono data-id="element-1225" />
                      <DetailRow label="Plan" value={p.plan} data-id="element-1226" />
                      <DetailRow label="Method" value={p.method} data-id="element-1227" />
                      <DetailRow label="Charged on" value={p.date} data-id="element-1228" />
                      <DetailRow label="Processed on" value={p.processedOn} data-id="element-1229" />
                      <DetailRow label="Account" value={`#${consumer.account}`} mono data-id="element-1230" />
                      {p.note && <div className="pt-2 mt-1 border-t border-gray-200" data-id="element-1231">
                          <p className="text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-1232">
                            Note
                          </p>
                          <p className="text-xs text-gray-600 leading-relaxed" data-id="element-1233">
                            {p.note}
                          </p>
                        </div>}
                      <div className="pt-2 flex items-center gap-2" data-id="element-1234">
                        <button className="text-xs font-bold text-brand-navy hover:text-brand-red transition-colors flex items-center gap-1" data-id="element-1235">
                          <FileText size={12} data-id="element-1236" /> View receipt
                        </button>
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ol>
    </div>;
}
function DetailRow({
  label,
  value,
  mono
}: {
  label: string;
  value: string;
  mono?: boolean;
}) {
  return <div className="flex justify-between text-xs gap-4" data-id="element-1237">
      <dt className="text-gray-500 shrink-0" data-id="element-1238">{label}</dt>
      <dd className={`font-bold text-brand-dark text-right truncate ${mono ? 'font-mono' : ''}`} data-id="element-1239">
        {value}
      </dd>
    </div>;
}
function AccountInfoTab({
  consumer
}: {
  consumer: Consumer;
}) {
  return <>
      <div className="px-6 py-5 border-b border-gray-100" data-id="element-1240">
        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3" data-id="element-1241">
          Personal Information
        </h4>
        <dl className="space-y-2.5" data-id="element-1242">
          <InfoRow label="First Name" value={consumer.firstName} data-id="element-1243" />
          <InfoRow label="Last Name" value={consumer.lastName} data-id="element-1244" />
          <InfoRow label="Address" value={consumer.address} data-id="element-1245" />
          <InfoRow label="City" value={consumer.city} data-id="element-1246" />
          <InfoRow label="State" value={consumer.state} data-id="element-1247" />
          <InfoRow label="Zip Code" value={consumer.zip} data-id="element-1248" />
          <InfoRow label="Date of Birth" value={consumer.dob} data-id="element-1249" />
          <InfoRow label="SSN Last 4" value={consumer.ssnLast4} mono data-id="element-1250" />
        </dl>
      </div>
      <div className="px-6 py-5 border-b border-gray-100" data-id="element-1251">
        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3" data-id="element-1252">
          Contact
        </h4>
        <dl className="space-y-2.5" data-id="element-1253">
          <InfoRow label="Phone" value={consumer.phone} data-id="element-1254" />
          <InfoRow label="Original Email" value={consumer.originalEmail} data-id="element-1255" />
          <InfoRow label="Current Email" value={consumer.currentEmail} data-id="element-1256" />
        </dl>
      </div>
      <div className="px-6 py-5" data-id="element-1257">
        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3" data-id="element-1258">
          Web Info & Permissions
        </h4>
        <div className="space-y-2" data-id="element-1259">
          <PermissionRow label="Portal Access" value={consumer.permissions.portalAccess} data-id="element-1260" />
          <PermissionRow label="Can Make Payments" value={consumer.permissions.canMakePayments} data-id="element-1261" />
          <PermissionRow label="Single ACH Accepted" value={consumer.permissions.singleAchAccepted} data-id="element-1262" />
          <PermissionRow label="Single Card Accepted" value={consumer.permissions.singleCardAccepted} data-id="element-1263" />
        </div>
      </div>
    </>;
}
function InfoRow({
  label,
  value,
  mono
}: {
  label: string;
  value: string;
  mono?: boolean;
}) {
  return <div className="flex justify-between text-sm gap-4" data-id="element-1264">
      <dt className="text-gray-500 shrink-0" data-id="element-1265">{label}</dt>
      <dd className={`font-medium text-brand-dark text-right truncate ${mono ? 'font-mono' : ''}`} data-id="element-1266">
        {value}
      </dd>
    </div>;
}
function PermissionRow({
  label,
  value
}: {
  label: string;
  value: boolean;
}) {
  return <div className="flex items-center justify-between py-1.5 text-sm" data-id="element-1267">
      <span className="text-gray-600" data-id="element-1268">{label}</span>
      {value ? <span className="flex items-center gap-1.5 text-green-700 font-bold text-xs" data-id="element-1269">
          <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-1270">
            <Check size={12} data-id="element-1271" />
          </span>
          Yes
        </span> : <span className="flex items-center gap-1.5 text-gray-400 font-bold text-xs" data-id="element-1272">
          <span className="w-5 h-5 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-1273">
            <Minus size={12} data-id="element-1274" />
          </span>
          No
        </span>}
    </div>;
}
function OfferTypeTag({
  type
}: {
  type: string;
}) {
  let color = 'bg-gray-100 text-gray-700 border-gray-200';
  if (type === 'Settlement') color = 'bg-green-50 text-green-700 border-green-200';else if (type === 'Plan') color = 'bg-blue-50 text-blue-700 border-blue-200';else if (type === 'Pay in Full') color = 'bg-purple-50 text-purple-700 border-purple-200';
  return <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-bold border ${color}`} data-id="element-1275">
      {type}
    </span>;
}
function ActionBadge({
  action
}: {
  action: string;
}) {
  let color = 'bg-gray-100 text-gray-600 border-gray-200';
  let dot = 'bg-gray-400';
  if (action === 'Expiring soon') {
    color = 'bg-amber-50 text-amber-700 border-amber-200';
    dot = 'bg-amber-500';
  } else if (action === 'On track') {
    color = 'bg-green-50 text-green-700 border-green-200';
    dot = 'bg-green-500';
  } else if (action === 'No response') {
    color = 'bg-red-50 text-red-700 border-red-200';
    dot = 'bg-red-500';
  } else if (action === 'Settled') {
    color = 'bg-gray-100 text-gray-500 border-gray-200';
    dot = 'bg-gray-400';
  }
  return <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold border ${color}`} data-id="element-1276">
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} data-id="element-1277"></span>
      {action}
    </span>;
}
function StatusBadge({
  status
}: {
  status: string;
}) {
  let color = 'bg-gray-100 text-gray-700 border-gray-200';
  if (status === 'Payment Plan') color = 'bg-blue-50 text-blue-700 border-blue-200';
  if (status === 'Paid') color = 'bg-gray-100 text-gray-500 border-gray-200';
  if (status === 'Delinquent') color = 'bg-red-50 text-red-700 border-red-200';
  return <span className={`px-2.5 py-1 rounded-full text-xs font-bold border ${color}`} data-id="element-1278">
      {status}
    </span>;
}